var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "share_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.616 20q-.69 0-1.153-.462A1.57 1.57 0 0 1 4 18.384V5.616q0-.69.463-1.153A1.57 1.57 0 0 1 5.615 4h5.616v1H5.616a.59.59 0 0 0-.424.192.59.59 0 0 0-.192.423v12.77q0 .23.192.423.193.192.423.192h12.77a.59.59 0 0 0 .423-.192.59.59 0 0 0 .192-.424V12.77h1v5.615q0 .69-.462 1.154a1.57 1.57 0 0 1-1.154.462zm4.123-5.03-.708-.709L18.292 5H14V4h6v6h-1V5.708z"
  }))));
};
export default SvgShare;